import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "~/lib/orpc-client";
import { QUERY_KEYS } from "~/constants/queryKeys";
import CollaboratorDetailHeader from "~/components/application/shared/collaborator-detail-header";
import CollaboratorInfoCard from "~/components/application/shared/collaborator-info-card";

export const Route = createFileRoute(
  "/applications/$applicationId/collaborators/$collaboratorId"
)({
  component: CollaboratorDetailComponent,
});

function CollaboratorDetailComponent() {
  const { applicationId, collaboratorId } = Route.useParams();
  const navigate = useNavigate();

  const { data: collaboratorData, isLoading, isError } = useQuery({
    queryKey: QUERY_KEYS.COLLABORATOR_BY_ID(collaboratorId),
    queryFn: () =>
      apiClient.collaborators.getById({
        id: Number(collaboratorId),
      }),
    enabled: !!collaboratorId,
  });

  const handleBackClick = () => {
    navigate({
      to: "/applications/$applicationId",
      params: { applicationId },
    });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-6xl mx-auto p-6">
          <p className="">Loading collaborator details...</p>
        </div>
      </div>
    );
  }

  if (isError || !collaboratorData) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-6xl mx-auto p-6">
          <p className="text-destructive">Failed to load collaborator details</p>
        </div>
      </div>
    );
  }

  const { collaborator } = collaboratorData;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        <CollaboratorDetailHeader
          collaborator={collaborator}
          applicationId={applicationId}
          onBackClick={handleBackClick}
        />
        <CollaboratorInfoCard collaborator={collaborator} />
      </div>
    </div>
  );
}
